import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import OrderpomappingEditForm from './OrderpomappingEditForm';
import OrderpomappingList from './OrderpomappingList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import OrderpomappingListView from './OrderpomappingListView'


export default function OrderpomappingDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.orderpomappingDashboard);
  const [ orderpomappingId, setOrderpomappingId] = React.useState('');
  const [reloadOrderpomappingList, setReloadOrderpomappingList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <OrderpomappingEditForm 
            setReloadOrderpomappingList={setReloadOrderpomappingList}
            orderpomappingId={orderpomappingId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <OrderpomappingListView 
                      setOrderpomappingId = {setOrderpomappingId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
